import React, { Component, createRef } from 'react';
import { withStyles, Button, TextField, Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faWindowMaximize, faInfoCircle, faExchange, faSquare, faFileDownload, faClipboard } from '@fortawesome/pro-regular-svg-icons';
import { faEllipsisH, faLongArrowRight } from '@fortawesome/pro-light-svg-icons';
import { faChevronDown as faChevronDownSolid, faCalendarDay, faUniversity, faCalendarAlt, faCopy, faTrash, faPen, faCheck, faUserCrown, faPlay, faPause, faStop, faEraser, faExchangeAlt } from '@fortawesome/pro-solid-svg-icons';
import LockIcon from '@material-ui/icons/Lock';
import {
	updateMAINworkPlans, updateSpinnerShow, updateSchedulePatternsTemplates, updateSelectedWorkPlan, updateSchedulePatternsTemplatesDetails, manageShiftLines,
	updateShiftTemplatesDetails, updateManageShiftLines, updateSnackbar, updateSelectedPaycode, updatePaycodeList, updateSidePanelData,
	updateEmployeeList, updateDataviewData, updateDataviewColumns, updateTableColumns, updateTotalsColumns,
	initWorkplanObjectsLists, updateSelectAllShiftLines, updateSelectAll,
	updateGetWorkplanDetails, updateSelectedPaycodeColumns, updateSelectedPaycodeColumnsSidePanelData, updateWorkplanWarnings, updateWorkplanAsyncTaskProgress,
	setWorkplanWarningsToLoading,
} from '../actions';
import axios from 'axios';
import ActionForm from './actionForm';
import WorkplanWarnings from './Warnings/workplanWarnings'
import { ColumnsManager, UploadExcel } from './ActionBar/index'
import AddShiftLinesMenu from './addShiftLinesMenu';
import { formatShiftLinesToSave, genData, genQuotas, getShiftLineHeight, evalForeverDateToString, isStateIndirect } from './functions';
import clsx from 'clsx';
import CustomSelect from './customSelect';
import EmployeeOptionsMenu from './employeeOptionsMenu';
import moment from 'moment';
import MouseTooltip from 'react-sticky-mouse-tooltip';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import ShiftLineOptionsMenu from './shiftLineOptionsMenu';
import Snackbar from '../../UI/Snackbar/Snackbar';
import EmployeeDataviewTooltip from '../../UI/Tooltip/EmployeeDataviewTooltip';
import WorkplanActionOptions from './workplanActionOptions'
import { isNull } from 'util';
import { exists, displayOrgpath, formatDataviewData, currentHttpOptions } from '../../../../common/utilities/utilitiesFunctions';
import { ChipTagStatus, CustomButton, CustomToolTip, Dialog, ReactSelect, ShiftCard, SimpleDialog, GroupedIconButton } from '../../../../common/components/UI/';
import { workplanTableIndex } from '../../../styles/workplanStyles';
import { cloneDeep, uniq } from 'lodash';
import * as aux from '../../../auxilaries';
import { isShiftlineEmployeeStopped } from './index.service';
import { getAsyncTaskSuccessLabel } from '../../../Enums/Helpers/LabellingHelper';
import { getAsyncTaskType } from '../../../Enums/Helpers/AsyncTaskHelper';
import {
	DaysOfWeekKeys,
	PlanTypes,
	ShiftLineCurrentStatus,
	StateStatus,
	WorkplanActions,
	WorkplanCurrentStatus,
	WorkplanStatus,
	UkgDateFormat
} from '../../../Enums/index';
import WorkplanShiftlineTable from './WorkplanShiftlineTable/index';
import WorkplanQuotaTable from './WorkplanQuotaTable/index';
import ReloadCoverageButton from './ReloadCoverageButton';
import { getIsAsyncTaskProcessing } from './WorkPlan.service';
import './index.scss';
import DateFormatService from '../../../services/DateFormatService';

const customSelectStyles = {
	control: base => ({
		...base,
		height: 36,
		minHeight: 36
	}),
	menuPortal: base => ({
		...base,
		position: "absolute",
		zIndex: 13010
	}),
	indicatorSeparator: () => ({
		display: 'none'
	})
}

const customSelectStylesTd = {
	control: base => ({
		...base,
		height: 28,
		minHeight: 28
	}),
	menuPortal: base => ({
		...base,
		position: "absolute",
		zIndex: 13010,
		minWidth: 400
	}),
	menu: base => ({
		...base,
		minWidth: 400
	}),
	menuList: base => ({
		...base,
		minWidth: 400
	}),
	option: base => ({
		...base,
		minWidth: 400,
		whiteSpace: 'nowrap'
	}),
	indicatorSeparator: () => ({
		display: 'none'
	}),
	indicatorsContainer: () => ({
		height: 28,
		padding: '0px 3px 0px 0px',
		'& div': {
			padding: '4px 0px'
		}
	}),
	valueContainer: () => ({
		height: 28,
		paddingTop: 3
	})
}
const customSelectStylesTdError = {
	menuPortal: base => ({
		...base,
		position: "absolute",
		zIndex: 13010,
		minWidth: 400
	}),
	menu: base => ({
		...base,
		minWidth: 400
	}),
	menuList: base => ({
		...base,
		minWidth: 400
	}),
	option: base => ({
		...base,
		minWidth: 400,
		whiteSpace: 'nowrap'
	}),
	control: base => ({
		...base,
		borderColor: 'red',
		height: 28,
		minHeight: 28
	}),
	indicatorSeparator: () => ({
		display: 'none'
	}),
	indicatorsContainer: () => ({
		height: 28,
		padding: '0px 3px 0px 0px',
		'& div': {
			padding: '4px 0px'
		}
	}),
	valueContainer: () => ({
		height: 28,
		paddingTop: 3
	})
}

const styles = theme => (workplanTableIndex(theme));

class WorkPlanView extends Component {
	constructor(props) {
		super(props);
		const { selectedWorkPlan, settingsList, updateTotalsColumns, t } = this.props;
		let workplanSettings = settingsList.find((setting) => setting.id === selectedWorkPlan.adminSettingId);
		const dataVisibility = workplanSettings && workplanSettings.content.dataVisibility;
		if (dataVisibility !== undefined) {
			const totalsColumns = [
				{
					label: t('workPlanList.columns.weeklyHours'),
					key: 'weeklyHours',
					visible: dataVisibility.weeklyHours && dataVisibility.weeklyHoursByDefault,
					disabled: !dataVisibility.weeklyHours
				}
			];

			updateTotalsColumns({ totalsColumns });
		}


		this.state = {
			checkedAll: false,
			columns: [],
			leftColumns: [],
			centerColumns: [],
			rightColumns: [],
			fixedColumnsLeft: 4,
			fixedColumnsRight: 0,
			limit: 30,
			page: 1,
			isMouseTooltipVisible: false,
			mouseTooltip: '',
			data: [],
			orgpaths: [],
			selectedShiftLines: 0,
			enableCopy: false,
			enableDelete: false,
			editMode: false,
			formTitle: "",
			selectedShiftTemplate: '',
			selectedSchedulePatternTemplate: '',
			startTimePaycode: '00:00',
			durationPaycode: 0,
			employeeList: [],
			selectedEmployee: {},
			showDeleteDialog: false,
			showCancelShiftLinesEdit: false,
			disableToolbar: false,
			workplanActionOptions: [
				{ label: t('workPlan.RolloutWorkplan'), value: WorkplanActions.RolloutWorkplan, icon: 'play', edit: false, disabled: true, isShowProgress: false },
				{ label: t('workPlan.PauseWorkplan'), value: WorkplanActions.PauseWorkplan, icon: 'pause', edit: false, disabled: false, isShowProgress: false },
				{ label: t('workPlan.StopWorkplan'), value: WorkplanActions.StopWorkplan, icon: 'stop', edit: false, disabled: false, isShowProgress: false }
			],
			width: 0,
			height: 0,
			displayDialog: false,
			copiedElement: null,
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
		this.taskProgressionInterval = React.createRef(null);
	}

	async componentDidMount() {
		const { selectedWorkPlan, initWorkplanObjectsLists, updateSpinnerShow, updateDataviewColumns } = this.props;
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
		updateSpinnerShow(true);
		let employeeList, schedulePatternsTemplates, payCodeAndShiftTemplate, dataviewColumns, skillAndCertificationProfiles
		try {
			this.getWorkplanDetails();
			this.getWorkplanWarnings();
			[employeeList, schedulePatternsTemplates, payCodeAndShiftTemplate, dataviewColumns, skillAndCertificationProfiles] = await Promise.all([
				axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetEmployeeList/' + selectedWorkPlan.workplanId, currentHttpOptions()),
				axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetSchedulePatterns/' + selectedWorkPlan.workplanId, currentHttpOptions()),
				axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetKronosPayCodeAndShiftTemplate', currentHttpOptions()),
				axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetDataviewColumns/' + selectedWorkPlan.workplanId, currentHttpOptions()),
				axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetSkillAndCertificationProfiles', currentHttpOptions())
			])
			schedulePatternsTemplates = schedulePatternsTemplates.data.schedulePatterns.map(pattern => { return { label: pattern.name, value: pattern.schedulePatternId } }).sort((a, b) => {
				if (a.label.toLowerCase() < b.label.toLowerCase())
					return -1;
				if (a.label.toLowerCase() > b.label.toLowerCase())
					return 1;
				return 0;
			});
			let payCodes = payCodeAndShiftTemplate.data.payCodes.map(paycode => { return { label: paycode.name, value: paycode.id } });
			dataviewColumns = dataviewColumns.data.columnsInformation;
			let shiftTemplates = payCodeAndShiftTemplate.data.shiftTemplate.map(shift => { return { label: shift.name, value: shift.id } });
			employeeList = employeeList.data.employeeList.map(ee => {
				return {
					value: ee.employeeId,
					label: ee.employeeName,
					jobs: ee.jobs,
					personNumber: ee.personNumber,
					transferNodes: ee.transferNodes
				}
			});

			skillAndCertificationProfiles = skillAndCertificationProfiles.data;
			await updateDataviewColumns(dataviewColumns);
			await initWorkplanObjectsLists({
				schedulePatternsTemplates,
				payCodes,
				dataviewColumns,
				shiftTemplates,
				employeeList,
				skillAndCertificationProfiles
			});
		} catch (ex) {
			let errorMessage = aux.handleAPIErrors(ex.response)
			this.props.updateSnackbar({
				typeSnackbar: 'error',
				messageSnackbar: errorMessage,
				openSnackbar: true,
			})
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
		const { selectedWorkPlan } = this.props;
		const isAsyncTaskProcessing = getIsAsyncTaskProcessing(selectedWorkPlan);
		
		if (isAsyncTaskProcessing && this.taskProgressionInterval.current !== null) {
			clearInterval(this.taskProgressionInterval.current);
			this.taskProgressionInterval.current = null;
		}
	}


	updateWindowDimensions() {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	}

	getWorkplanWarnings = async () => {
		const { setWorkplanWarningsToLoading, updateWorkplanWarnings, selectedWorkPlan } = this.props;
		setWorkplanWarningsToLoading();
		axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetWorkplanWarnings/' + selectedWorkPlan.workplanId, currentHttpOptions()).then((response) => {
			updateWorkplanWarnings({ employeeWarnings: response.data });
		}).catch(ex => {
			let errorMessage = aux.handleAPIErrors(ex.response)
			this.props.updateSnackbar({
				typeSnackbar: 'error',
				messageSnackbar: errorMessage,
				openSnackbar: true,
			})
		})
	}

	getWorkplanDetails = async () => {
		const { selectedWorkPlan, updateSpinnerShow, updateGetWorkplanDetails, settingsList, t } = this.props;

		updateSpinnerShow(true);
		let workplan
		try {
			workplan = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetWorkplanDetails/' + selectedWorkPlan.workplanId, currentHttpOptions());
			await this.getEmployeeDataview(workplan)
		} catch (ex) {
			let errorMessage = aux.handleAPIErrors(ex.response)
			this.props.updateSnackbar({
				typeSnackbar: 'error',
				messageSnackbar: errorMessage,
				openSnackbar: true,
			})
			return Promise.reject(new Error(errorMessage)); // break out if this fails
		}
		let nbDays = workplan.data.periodType === "Weeks" ? workplan.data.periodLength * 7 : workplan.data.periodLength;

		workplan = {
			...workplan.data,
			jobs: workplan.data.jobs.map(job => { return { value: job.nodeId, label: job.orgPath, parentNodeId: job.parentNodeId } }),
			currentStatus: workplan.data.currentStatus,
			nbDays,
			deletedLines: [],
			quotas: [],
			states: workplan.data.states !== null ? workplan.data.states : [],
			startDate: exists(workplan.data.startDate) ? workplan.data.startDate.substring(0, 10) : '',
			endDate: exists(workplan.data.endDate) ? workplan.data.endDate.substring(0, 10) : '',
		};
		let workplanSettings = settingsList.find((setting) => setting.id === workplan.adminSettingId) || {};
		genData(workplan, workplanSettings);
		let columns = await this.genColumns(workplan, false, false, false);
		const accessProfiles = {
			createTemplates: workplan.accessProfiles.createTemplates,
			manageShiftlines: workplan.accessProfiles.manageShiftlines,
			manageAssignments: workplan.accessProfiles.manageAssignments,
		};

		updateGetWorkplanDetails({ selectedWorkPlan: workplan, columns, accessProfiles })

		this.setState({
			workplanActionOptions: [
				{
					label: t('workPlan.RolloutWorkplan'),
					value: WorkplanActions.RolloutWorkplan,
					icon: workplan.states.length > 0 ? faPen : faPlay,
					edit: workplan.status === WorkplanStatus.Played,
					disabled: this.disableWorkplanAction(workplan, 'Rollout'),
					isShowProgress: workplan.isRollingOut,
				},
				{
					label: t('workPlan.PauseWorkplan'),
					value: WorkplanActions.PauseWorkplan,
					icon: exists(workplan.states.find(state => state.label === 'Paused')) ? faPen : faPause,
					edit: exists(workplan.states.find(state => state.label === 'Paused')),
					disabled: this.disableWorkplanAction(workplan, 'Pause'),
					isShowProgress: workplan.isPausing,
				},
				{
					label: t('workPlan.StopWorkplan'),
					value: WorkplanActions.StopWorkplan,
					icon: faStop,
					edit: false,
					disabled: this.disableWorkplanAction(workplan, 'Stop'),
					isShowProgress: workplan.isStopping,
				}
			],
		});
		Promise.resolve("Success");
	}

	getWorkplanDetailsAndWarnings = async () => {
		this.getWorkplanWarnings();
		this.getWorkplanDetails();
	}

	getEmployeeDataview = async (workplanDetails) => {
		const { updateDataviewData, dataviewData } = this.props;

		let employeeIds = [];

		for (let shiftLine of workplanDetails.data.shiftLines) {
			for (let owner of shiftLine.owners) {
				employeeIds.push(owner.employeeId)
			}
			for (let relief of shiftLine.reliefs) {
				employeeIds.push(relief.employeeId)
			}
		}
		employeeIds = uniq(employeeIds);

		let employeeDataviewList = {}
		let employeeIdsToRetrieve = []
		for (let employeeId of employeeIds) {
			if (dataviewData.find((x) => x[employeeId])) {
				employeeDataviewList[employeeId] = dataviewData[employeeId]
			} else {
				employeeIdsToRetrieve.push(employeeId)
			}
		}

		if (employeeIdsToRetrieve.length > 0) {
			try {
				const dataviews = await axios.post(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetEmployeeDataview',
					{ workplanId: workplanDetails.data.workplanId, employeeIds: employeeIdsToRetrieve }, currentHttpOptions())
				updateDataviewData([...dataviewData, ...dataviews.data.employeeDataviewList]);
			} catch (ex) {
				let errorMessage = aux.handleAPIErrors(ex.response)
				this.props.updateSnackbar({
					typeSnackbar: 'error',
					messageSnackbar: errorMessage,
					openSnackbar: true,
				})
			}
		}
	}

	disableWorkplanAction = (workplan, action) => {
		const { selectedWorkPlan } = this.props;
		const isAsyncTaskProcessing = getIsAsyncTaskProcessing(selectedWorkPlan);

		switch (action) {
			case 'Rollout':
				return (workplan.status === WorkplanStatus.Played 
					&& (
						moment().isAfter(moment(workplan.endDate))
						|| exists(selectedWorkPlan.states.find(state => state.label === 'Stopped'))
					))
					|| !workplan.shiftLines.length
					|| isAsyncTaskProcessing;
			case 'Pause':
				return workplan.states.length === 0
					|| moment(selectedWorkPlan.states[selectedWorkPlan.states.length - 1].endDate).isBefore(moment())
					|| isAsyncTaskProcessing;
			case 'Stop':
				return exists(workplan.states.find(state => state.label === 'Stopped'))
					|| workplan.states.length === 0
					|| moment(selectedWorkPlan.states[selectedWorkPlan.states.length - 1].endDate).isBefore(moment())
					|| isAsyncTaskProcessing;
			default:
				return false;
		}
	}

	errorHandler = (error, disableCards = false) => {
		this.props.updateSnackbar({ typeSnackbar: 'error', messageSnackbar: error, openSnackbar: true });
		this.setState({
			disableSelects: disableCards,
			disableCardS: disableCards
		});
	}

	displayDialog = (state, type) => {
		this.setState({
			displayDialog: state,
			planType: type
		});
	}

	closeSnackbar = () => {
		this.props.updateSnackbar({ typeSnackbar: '', messageSnackbar: '', openSnackbar: false });
	}

	handleEmployeeActions = (action, shiftLine, shiftLineOwner) => {
		const { updateSidePanelData, employeeList, t } = this.props;

		updateSpinnerShow(true);
		let employeeListAux = [];
		let job = shiftLine.job;
		if (exists(job) && job.label !== "") {
			for (const employee of employeeList) {
				if (employee.jobs.find(x => x.jobId === job.value)) {
					employeeListAux.push(employee);
				}
			}
		}

		updateSidePanelData({ formTitle: t('workPlanView.global.' + action), action, shiftLine, shiftLineOwner, employeeList: employeeListAux });
	}

	handleSetJobTransfer = (shift, shiftlineJob, shiftTemplateDay, shiftlineId) => {
		const { updateSidePanelData, refreshAdmin, t } = this.props;

		updateSidePanelData({ formTitle: t('workPlan.setJobTransfer'), action: WorkplanActions.AddJobTransfer, shift, shiftlineJob, refreshAdmin, shiftTemplateDay, shiftlineId });
	}

	handleSetSkillAndCertificationProfiles = (shift, shiftlineJob, shiftTemplateDay, shiftlineId) => {
		const { updateSidePanelData, refreshAdmin, t } = this.props;
		const shiftSegmentsSCP = shift.segments.map((segment) => ({ 
			...segment, 
			segmentSCProfiles: segment.segmentSCProfiles !== null 
				? segment.segmentSCProfiles.map((profile) => ({ value: `${profile.id}`, label: profile.qualifier})) 
				: null
		}));
		updateSidePanelData({ formTitle: t('workPlan.setSkillAndCertificationProfiles'), action: WorkplanActions.SetSkillAndCertificationProfiles, shift, shiftlineJob, refreshAdmin, shiftTemplateDay, shiftlineId, shiftSegmentsSCP });
	}

	handleShiftLineActions = (action, shiftLine) => {
		let selectedStartDate, selectedEndDate;

		if (action === 'EditPauseShiftLine') {
			selectedStartDate = shiftLine.pauseStates.find(x => x.status === 1).effectiveDate;
			selectedEndDate = shiftLine.pauseStates.find(x => x.status === 1).endDate;
		}

		if (action === 'EditStopShiftLine') {
			selectedEndDate = shiftLine.stopStates.find(x => x.status === 2).endDate;
		}

		this.props.updateSidePanelData({ formTitle: this.props.t('workPlan.' + action), action, shiftLine, selectedStartDate, selectedEndDate });
	}

	handleToggleAction = async (target, value) => {
		const { selectedWorkPlan, manageShiftLines, updateSelectedPaycodeColumns, updateSelectedPaycodeColumnsSidePanelData } = this.props;
		const { startTimePaycode, durationPaycode, displayQuota, checkedAll } = this.state;

		switch (target) {
			case 'selectedShiftTemplate':
				let shiftTemplate = value === null ? '' : await this.getShiftTemplate(value.value);
				updateSelectedPaycodeColumns({ selectedPaycode: '', columns: this.genColumns(selectedWorkPlan, true, false, checkedAll) })
				this.setState({
					selectedShiftTemplate: shiftTemplate || '',
					enableCopy: false,
					enableDelete: false,
					selectedSchedulePatternTemplate: '',
					mouseTooltip: shiftTemplate === '' ? '' : shiftTemplate.name
				});
				break;
			case 'selectedPaycode':
				updateSelectedPaycodeColumnsSidePanelData({
					selectedPaycode: value === null ? '' : value,
					columns: this.genColumns(selectedWorkPlan, true, false, checkedAll),
					sidePanelData: { formTitle:  this.props.t('workPlan.paycode.addPaycode'), action: "createPaycode", paycode: value, startTimePaycode, durationPaycode }
				})
				this.setState({
					enableCopy: false,
					enableDelete: false,
					selectedShiftTemplate: '',
					selectedSchedulePatternTemplate: '',
					mouseTooltip: value === null ? '' : value.label
				});
				break;
			case 'selectedSchedulePatternTemplate':
				let pattern = value === null ? '' : await this.getSchedulePattern(value.value);
				updateSelectedPaycodeColumns({ selectedPaycode: '', columns: this.genColumns(selectedWorkPlan, true, false, checkedAll) })
				this.setState({
					selectedSchedulePatternTemplate: pattern === '' ? '' : { value: pattern.value, label: pattern.label },
					enableCopy: false,
					enableDelete: false,
					selectedShiftTemplate: '',
					mouseTooltip: pattern === '' ? '' : pattern.label
				});
				break;

			case 'enableCopy':
				updateSelectedPaycodeColumns({ selectedPaycode: '', columns: this.genColumns(selectedWorkPlan, true, false, checkedAll) })
				this.setState({
					isMouseTooltipVisible: false,
					enableCopy: !this.state.enableCopy,
					enableDelete: false,
					selectedShiftTemplate: '',
					selectedSchedulePatternTemplate: '',
					mouseTooltip: '',
					copiedElement: null,
				});
				break;
			case 'enableDelete':
				updateSelectedPaycodeColumns({ selectedPaycode: '', columns: this.genColumns(selectedWorkPlan, true, false, checkedAll) })
				this.setState({
					isMouseTooltipVisible: false,
					enableDelete: !this.state.enableDelete,
					enableCopy: false,
					selectedShiftTemplate: '',
					selectedSchedulePatternTemplate: '',
					mouseTooltip: ''
				});
				break;
			case 'manageShiftLines':
				let shiftLines = [
					...selectedWorkPlan.shiftLines.filter(d => d.checked).map(d => { return { ...d, editMode: true, checked: false } }),
					...selectedWorkPlan.shiftLines.filter(d => !d.checked).map(d => { return { ...d, editMode: false, checked: false } })
				];

				let workplan = { ...selectedWorkPlan, shiftLines };

				await this.setState({
					page: 1,
					enableCopy: false,
					enableDelete: false,
					editMode: true,
					checkedAll: false,
					selectedShiftTemplate: '',
					selectedSchedulePatternTemplate: '',
					selectedShiftLines: 0
				});
				let columns = this.genColumns(workplan, true, false, false);
				// To fix workplan init ref
				manageShiftLines({
					selectedWorkPlan: workplan, selectedWorkPlanInitial: workplan, manageShiftLines: true, columns, selectedPaycode: ''
				});
				break;
			case 'displayQuota':
				this.setState({ displayQuota: !displayQuota });
				break;
			case 'deleteLines':
				this.setState({
					showDeleteDialog: true
				});
				break;
			default:
				break;
		}
	}

	genButtonAction = (action, icon, target, value, label, disabled = false) => {
		const { classes } = this.props;
		return <CustomToolTip enterDelay={500} leaveDelay={500} titletext={label} jsx={
			<span>
				<Button
					style={{ minWidth: 34 }}
					className={clsx(classes.tableColumnButton, value ? classes.buttonSelected : '', disabled ? classes.buttonDisabled : '')}
					disabled={disabled}
					onClick={(e) => {
						action(target);
						e.stopPropagation();
					}}>
					{<FontAwesomeIcon icon={icon} />}
				</Button>
			</span>
		} />
	}

	genColumns = (workplan, editMode = false, onSave = false, checkedAll) => {
		const { centerColumns } = this.state;
		let leftColumns = this.genLeftColumns(workplan, editMode, onSave, checkedAll);
		let totalColumns = editMode ? [] : this.genTotalsColumns();
		let centerColumnsUpdate = centerColumns.length ? centerColumns : this.genCenterColumns(workplan);
		let columns = [
			...leftColumns,
			...totalColumns,
			...centerColumnsUpdate,
		]
		if (!centerColumns.length) {
			this.setState({ centerColumns: centerColumnsUpdate });
		}
		this.setState({ columns: columns });
		return columns;

	}

	handleClickDay = async (e, rowData, day) => {
		const { selectedWorkPlan, shiftTemplatesDetails, selectedPaycode, manageShiftLines, selectedWorkPlanInitial, settingsList } = this.props;
		const { selectedShiftTemplate, selectedSchedulePatternTemplate, copiedElement, enableCopy, enableDelete, checkedAll } = this.state;
		let workplan = Object.assign({}, selectedWorkPlan);
		let shiftLines = Object.assign([], workplan.shiftLines);
		let shiftline = shiftLines.find((x) => x.shiftLineId === rowData.shiftLineId)

		if (shiftline.editMode && !enableDelete) {
			if (enableCopy && copiedElement) {
				if (!exists(shiftline[day])) {
					shiftline[day] = [];
				}
				shiftline[day].push(copiedElement);

			} else if (selectedSchedulePatternTemplate !== '') {
				shiftline.schedulePatternName = shiftline.schedulePatternName === '' ? selectedSchedulePatternTemplate.label : shiftline.schedulePatternName;
				shiftline.schedulePatternId = selectedSchedulePatternTemplate.value;
				let pattern = await this.getSchedulePattern(selectedSchedulePatternTemplate.value);

				let newDays = this.genDaysFromPatternTemplate(pattern);
				for (const day in newDays) {
					if (newDays.hasOwnProperty(day)) {
						if (!exists(shiftline[day])) {
							shiftline[day] = newDays[day];
						} else {
							shiftline[day] = [...shiftline[day], ...newDays[day]];
						}
					}
				}
			} else if (selectedShiftTemplate !== '' || selectedPaycode !== '') {
				if (!exists(shiftline[day])) {
					shiftline[day] = [];
				}
				if (selectedShiftTemplate !== '') {
					shiftline[day].push(shiftTemplatesDetails[selectedShiftTemplate.id]);
				} else {
					shiftline[day].push({
						id: selectedPaycode.value,
						name: selectedPaycode.label,
						durationInTime: selectedPaycode.duration,
						startTime: selectedPaycode.startTime
					});
				}
			}

			shiftline.maxItemsByDay = getShiftLineHeight(shiftline, selectedWorkPlan);
			workplan = Object.assign({}, { ...workplan, shiftLines });

			const workplanSettings = settingsList.find((setting) => setting.id === selectedWorkPlan.adminSettingId) || {};
			const enableSystemCoverage = workplanSettings.content.coverage.enableSystemCoverage;
			workplan.quotas = await genQuotas(workplan, enableSystemCoverage);

			let columns = await this.genColumns(workplan, true, false, checkedAll);
			manageShiftLines({ selectedWorkPlan: workplan, selectedWorkPlanInitial, manageShiftLines: true, columns, selectedPaycode });
		}
		e.stopPropagation();
	}

	handleClickScheduleItem = (e, rowData, day, index) => {
		const { selectedWorkPlan, updateSelectedWorkPlan, shiftTemplatesDetails, updateShiftTemplatesDetails, updateSelectedPaycode, settingsList } = this.props;
		const { enableCopy, enableDelete } = this.state;
		const workplan = { ...selectedWorkPlan };
		const isActionAvailable = rowData.editMode && (enableDelete || enableCopy);

		if (isActionAvailable) {
			if (enableDelete) {
				const shiftline = workplan.shiftLines.find(x => x.shiftLineId === rowData.shiftLineId)
				shiftline[day].splice(index, 1);
				shiftline.maxItemsByDay = getShiftLineHeight(shiftline, selectedWorkPlan);

				const workplanSettings = settingsList.find((setting) => setting.id === selectedWorkPlan.adminSettingId) || {};
				const enableSystemCoverage = workplanSettings.content.coverage.enableSystemCoverage;
				workplan.quotas = genQuotas(workplan, enableSystemCoverage);
				updateSelectedWorkPlan(workplan);
			}

			if (enableCopy) {
				const shiftline = workplan.shiftLines.find(x => x.shiftLineId === rowData.shiftLineId)

				let item = shiftline[day][index];
				if (!item) {
					return;
				}
				if (exists(item.segments) || (exists(item.kronosShiftTemplate) && exists(item.kronosShiftTemplate.segments))) {
					let auxShiftTemplatesDetails = Object.assign({}, shiftTemplatesDetails);
					if (!exists(shiftTemplatesDetails[item.id])) {
						auxShiftTemplatesDetails[item.id] = item;
						updateShiftTemplatesDetails(auxShiftTemplatesDetails);
					}
					this.setState({
						selectedShiftTemplate: item,
						mouseTooltip: item.label
					});
				} else {
					let paycode = { value: item.id, label: item.name, startTime: item.startTime, duration: item.durationInTime };
					updateSelectedPaycode(paycode);
				}
				this.setState({ copiedElement: item });
			}
		}
		e.stopPropagation();
	}

	getSchedulePattern = async (schedulePatternTemplateId) => {
		const { updateSpinnerShow, updateSchedulePatternsTemplatesDetails, schedulePatternsTemplatesDetails } = this.props;

		if ((exists(schedulePatternsTemplatesDetails) && !exists(schedulePatternsTemplatesDetails[schedulePatternTemplateId])) || !exists(schedulePatternsTemplatesDetails)) {
			updateSpinnerShow(true);
			try {
				let schedulePattern = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetSchedulePatternDetails/' + schedulePatternTemplateId, currentHttpOptions());
				schedulePattern.data.value = schedulePattern.data.id;
				schedulePattern.data.label = schedulePattern.data.name;

				let auxSchedulePatternsTemplatesDetails = Object.assign({}, schedulePatternsTemplatesDetails);
				auxSchedulePatternsTemplatesDetails[schedulePattern.data.id] = schedulePattern.data;
				updateSchedulePatternsTemplatesDetails(auxSchedulePatternsTemplatesDetails);

				return schedulePattern.data;
			} catch (ex) {
				let errorMessage = aux.handleAPIErrors(ex.response)
				this.props.updateSnackbar({
					typeSnackbar: 'error',
					messageSnackbar: errorMessage,
					openSnackbar: true,
				})
			}
		} else {
			return schedulePatternsTemplatesDetails[schedulePatternTemplateId];
		}
	}

	getEmployeeList = async () => {
		const { selectedWorkPlan } = this.props;
		try {
			let employeeList = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetEmployeeList/' + selectedWorkPlan.workplanId, currentHttpOptions());
			let data = employeeList.data.employeeList.map(ee => {
				return {
					value: ee.employeeId, label: ee.employeeName,
					jobs: ee.jobs, personNumber: ee.personNumber, transferNodes: ee.transferNodes
				}
			});
			return ({ employeeList: data })
		} catch (ex) {
			let errorMessage = aux.handleAPIErrors(ex.response)
			this.props.updateSnackbar({
				typeSnackbar: 'error',
				messageSnackbar: errorMessage,
				openSnackbar: true,
			})
			return ({ employeeList: [] })
		}
	}

	getShiftTemplate = async (shiftTemplateId) => {
		const { updateSpinnerShow, updateShiftTemplatesDetails, shiftTemplatesDetails } = this.props;
		if ((exists(shiftTemplatesDetails) && !exists(shiftTemplatesDetails[shiftTemplateId])) || !exists(shiftTemplatesDetails)) {
			updateSpinnerShow(true);
			try {
				let shiftTemplate = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetkronosShiftTemplate/' + shiftTemplateId, currentHttpOptions());
				let auxShiftTemplatesDetails = Object.assign({}, shiftTemplatesDetails);
				auxShiftTemplatesDetails[shiftTemplate.data.id] = shiftTemplate.data;
				await updateShiftTemplatesDetails(auxShiftTemplatesDetails);

				return shiftTemplate.data;
			} catch (ex) {
				let errorMessage = aux.handleAPIErrors(ex.response)
				this.props.updateSnackbar({
					typeSnackbar: 'error',
					messageSnackbar: errorMessage,
					openSnackbar: true,
				})
				return []
			}
		} else {
			return shiftTemplatesDetails[shiftTemplateId];
		}
	}

	onRowClick = async (event, rowData) => {
		const { selectedWorkPlan, updateSelectedWorkPlan } = this.props;
		const { selectedSchedulePatternTemplate } = this.state;

		if (selectedSchedulePatternTemplate !== '') {
			let shiftLines = Object.assign([], selectedWorkPlan.shiftLines);

			let selectedShiftline = shiftLines.find((x) => x.shiftLineId === rowData.shiftLineId)
			selectedShiftline.schedulePatternName = selectedSchedulePatternTemplate.label;
			selectedShiftline.schedulePatternId = selectedSchedulePatternTemplate.value;
			let pattern = await this.getSchedulePattern(selectedSchedulePatternTemplate.value);

			let newDays = this.genDaysFromPatternTemplate(pattern);
			for (const day in newDays) {
				if (newDays.hasOwnProperty(day)) {
					if (!exists(selectedShiftline[day])) {
						selectedShiftline[day] = newDays[day];
					} else {
						selectedShiftline[day] = [...selectedShiftline[day], ...newDays[day]];
					}
				}
			}

			let workplan = Object.assign({}, { ...selectedWorkPlan, shiftLines });
			await updateSelectedWorkPlan(workplan);
		}
	}

	genDivCell = (rowData, i) => {
		const { selectedPaycode, selectedWorkPlan, t } = this.props;
		const { selectedSchedulePatternTemplate, selectedShiftTemplate, mouseTooltip, enableDelete, enableCopy } = this.state;
		let buttonDisabled;
		let days = [];

		if (rowData.currentStatus) {
			buttonDisabled = selectedWorkPlan.isLocked || rowData.isDisabled
				|| (rowData.currentStatus.value === ShiftLineCurrentStatus.Active
					&& selectedWorkPlan.currentStatus.value === WorkplanCurrentStatus.Active
					&& selectedWorkPlan.status === WorkplanStatus.Played)
				|| rowData.editMode === true;
		}
		else {
			buttonDisabled = selectedWorkPlan.isLocked || rowData.isDisabled
				|| (selectedWorkPlan.currentStatus.value === WorkplanCurrentStatus.Active
					&& (selectedWorkPlan.status === WorkplanStatus.Played || rowData.editMode === true))
				|| rowData.editMode === true;
		}

		if (exists(rowData["day" + i])) {
			for (const [index, item] of rowData["day" + i].entries()) {
				let shift;
				let paycode;
				if (exists(item.segments)) {
					shift = Object.assign({}, item);
				} else if (item.kronosShiftTemplate) {
					shift = Object.assign({}, item.kronosShiftTemplate);
				} else {
					paycode = Object.assign({}, item);
				}
				const isAsyncTaskProcessing = getIsAsyncTaskProcessing(selectedWorkPlan);
				days.push(
					<ShiftCard
						t={t}
						key={`shift-card-${rowData.shiftLineId}-${item.label}-${item.day}`}
						changePointer={rowData.editMode && (enableDelete || enableCopy)}
						handleClick={(e) => this.handleClickScheduleItem(e, rowData, "day" + i, index)}
						withTooltip={true}
						tooltipPlacement={'left'}
						isTemplate={true}
						shift={shift}
						paycode={paycode}
						disableMenuButton={buttonDisabled}
						onSetJobTransfer={() => this.handleSetJobTransfer(shift, rowData.job, i, rowData.shiftLineId)}
						onSetSkillAndCertificationProfiles={() => this.handleSetSkillAndCertificationProfiles(shift, rowData.job, i, rowData.shiftLineId)}
						isAsyncTaskProcessing={isAsyncTaskProcessing}
					/>
				)
			}
		}

		return (
			<div style={{
				height: 55,
				width: 188,
				zIndex: 9000,
				cursor: (rowData.editMode && (selectedSchedulePatternTemplate !== '' || selectedShiftTemplate !== '' || selectedPaycode !== '')) ? 'crosshair' : 'default',
				paddingTop: 3
			}}
				onClick={(e) => this.handleClickDay(e, rowData, "day" + i)}
				onMouseOut={() => { if (rowData.editMode && mouseTooltip !== '') this.setState({ isMouseTooltipVisible: false }) }}
				onMouseEnter={() => { if (rowData.editMode && mouseTooltip !== '') this.setState({ isMouseTooltipVisible: true }) }}
			>
				{days}
			</div>
		)
	};

	genDivZone = (rowData, i) => {
		const { classes, selectedWorkPlan, settingsList } = this.props;
		let value = <></>;
		const workplanSettings = settingsList.find((setting) => setting.id === selectedWorkPlan.adminSettingId) || {};
		const enableSystemCoverage = workplanSettings.content.coverage.enableSystemCoverage;

		if (exists(rowData["day" + i]) && (rowData["day" + i].part1 !== 0 || rowData["day" + i].part2 !== 0 || rowData["day" + i].part3 !== 0)) {
			value = (
				<div
					key={`${i}`}
					className={classes.divQuota}
				>
					<span className={rowData["day" + i].part1 < rowData["day" + i].part2 ? classes.quotaNegative : ''}>{rowData["day" + i].part1}</span>
					{"/"}
					<span className={rowData["day" + i].part2 < rowData["day" + i].part3 ? classes.quotaNegative : ''}>{rowData["day" + i].part2}</span>
					{enableSystemCoverage && "/"}
					{enableSystemCoverage && (<span>{rowData["day" + i].part3}</span>)}

				</div>
			);
		}

		return value;
	}



	genCenterColumns = (workplan) => {

		const { settingsList } = this.props;

		let workplanSettings = settingsList.find((setting) => setting.id === workplan.adminSettingId) || {};
		let firstDayOfWeek = workplanSettings.content.schedulePeriod.firstDayOfWeek || 0;

		let dayCount = 0;

		if (workplan.periodType === "Weeks") {
			dayCount = firstDayOfWeek;
		}

		let centerColumns = [];

		for (let i = 1; i <= workplan.nbDays; i++) {
			const dayLabel = DaysOfWeekKeys[dayCount] ? this.props.t(`common:dayOfWeek.${DaysOfWeekKeys[dayCount]}`) : '';

			centerColumns.push({
				title: workplan.periodType === "Weeks" ? `${dayLabel.substring(0, 3)}-${i}` : i,
				field: "day" + i,
				minWidth: 200,
				flexGrow: 3.5,
				sorting: false,
				className: "shiftline-table-row-day-cell",
				cellStyle: { padding: 0, border: '1px solid #E6EDF5' },
				render: (rowData) => {
					switch (rowData.type) {
						case 'zone':
							return this.genDivZone(rowData, i);
						case 'item':
							return this.genDivCell(rowData, i);
						case 'relief':
							return '';
						default: return '';
					}
				}
			})

			dayCount++;

			if (workplan.periodType === "Weeks") {
				dayCount %= 7;
			}
		}

		return centerColumns;
	}

	genTotalsColumns = () => {

		const { totalsColumns, classes } = this.props;

		const renderedTotalColumns = [];



		totalsColumns.forEach((col) => {
			if (!col.visible) {
				return;
			}
			renderedTotalColumns.push({
				title: col.label,
				field: col.key,
				width: 250,
				sorting: false,
				cellStyle: { padding: 0, border: '1px solid #E6EDF5' },
				render: (rowData) => (
					rowData.type === 'item' && rowData.weeklyHours ? (
						<div className={classes.totalsColumn}>
							<CustomToolTip
								titletext={rowData.weeklyHours.map((x, i) => (<div>{`Week ${i + 1} : ${x} hours`}</div>))}
								jsx={<div>{rowData.weeklyHours.join('/')}</div>}
							/>
						</div>
					) : ''
				)
			});
		});

		return renderedTotalColumns;
	}

	genEmployeeCell = (shiftLine, editMode = false) => {
		const { selectedWorkPlan, classes, t } = this.props;
		let refDivEE = createRef();
		let currentOwner = shiftLine.currentOwner;
		let currentRelief = shiftLine.currentRelief;
		let marginTop = 2;
		let employeeCell = '';

		const genEmployeeName = (name, isTransfer) => {
			const transferIcon = <FontAwesomeIcon style={{ marginLeft: '10px' }} icon={faExchangeAlt} />;
			// Translate "Unassigned" if it comes from the backend
			const displayName = name === 'Unassigned' ? t('workPlanView.employee.unassigned') : name;
			return (
				<div className={classes.employeeNameCell}>
					<span className={classes.employeeNameSpan}>{displayName}</span>
					{isTransfer && transferIcon}
				</div>
			)
		}


		if (shiftLine.editMode) {
			employeeCell = <div className={classes.divUnassigned}>
				{
					selectedWorkPlan.states.length === 0
						&& shiftLine.owners
						&& shiftLine.owners.length > 0
						? genEmployeeName(shiftLine.owners[0].employeeFullName, shiftLine.owners[0].isTransfer)
						: t('workPlanView.employee.unassigned')
				}
			</div>
		} else {
			if (shiftLine.type === 'item' && currentOwner === null && currentRelief === null) {
				employeeCell = <div className={classes.divUnassigned}>
					<div style={{ display: 'flex' }}>
						{<div style={{ marginRight: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{this.chipStatus(undefined)}</div>}
						<div style={{ width: '100%' }}>
							{
								selectedWorkPlan.states.length === 0 && shiftLine.owners.length > 0
									? genEmployeeName(shiftLine.owners[0].employeeFullName, shiftLine.onwers[0].isTransfer)
									: t('workPlanView.employee.unassigned')
							}
						</div>
					</div>
				</div>
			} else {
				let owner = <FontAwesomeIcon className={classes.iconOwner} icon={faUserCrown} />;

				if (shiftLine.type === 'item') {
					if (currentRelief === null && currentOwner !== null) {
						marginTop = 8;
						let currentOwnerState = currentOwner.states ? currentOwner.states.find(x => x.isCurrent) : null;

						const currentOwnerStateLabel = currentOwnerState && currentOwnerState.label;

						employeeCell = <div style={{ width: '100%' }}>
							<div style={{ display: 'flex', paddingTop: 6 }}>
								{currentOwner.states.length > 0
									? this.genListStatus(currentOwner.states, currentOwnerStateLabel)
									: <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{this.chipStatus(currentOwnerStateLabel)}</div>}
								{this.genEmployeeDataviewToolTip(
									<div style={{ marginLeft: 4, width: '100%' }}>{genEmployeeName(currentOwner.employeeFullName, currentOwner.isTransfer)}</div>,
									currentOwner.employeeId,
									genEmployeeName(currentOwner.employeeFullName, currentOwner.isTransfer))}
							</div>
						</div>;
					} else if (currentRelief !== null && currentOwner === null) {
						marginTop = 2;
						employeeCell = <div style={{ width: '100%' }}>
							<div style={{ display: 'flex' }}>
								{<div style={{ marginRight: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{this.chipStatus('Active')}</div>}
								<div style={{ width: '100%' }}>{genEmployeeName(currentRelief.employeeName, currentRelief.isTransfer)}</div>
							</div>
							<div style={{ fontSize: 10 }}>
								<FontAwesomeIcon className={classes.iconExchange} icon={faExchange} />
								{t('workPlanView.employee.noOwner')}
							</div>
						</div>;
					} else {
						marginTop = 0;
						employeeCell = <div style={{ width: '100%' }}>
							<div style={{ display: 'flex' }}>
								{<div style={{ marginRight: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{this.chipStatus('Active')}</div>}
								<div style={{ width: '100%' }}>{genEmployeeName(currentRelief.employeeName, currentRelief.isTransfer)}</div>
							</div>
							{currentOwner === null ? '' : <div style={{ fontSize: 10, display: 'flex' }}>
								<FontAwesomeIcon className={classes.iconExchange} icon={faExchange} />
								{genEmployeeName(currentOwner.employeeFullName, currentOwner.isTransfer)}{owner}</div>}
						</div>;
					}
				} else if (shiftLine.type === 'relief') {
					marginTop = 3;
					if (shiftLine.sumSummaryReliefStatusLabel !== "NotCovered" && shiftLine.sumSummaryReliefStatusLabel !== "Stopped") {
						let currentRelief = false;

						if (shiftLine.startDate === null) {
							currentRelief = moment().isAfter(moment(shiftLine.endDate.substring(0, 10)));
						} else {
							currentRelief = moment().isBetween(
								moment(shiftLine.startDate.substring(0, 10)),
								moment(shiftLine.endDate.substring(0, 10)),
								'd', '[]'
							);
						}

						let eeName = genEmployeeName(shiftLine.employeeName, shiftLine.isTransfer);
						if (shiftLine.summaryReliefStatus === 3) {
							eeName = t(`workPlanView.SummaryReliefStatus.${shiftLine.sumSummaryReliefStatusLabel}`);
						} else if (shiftLine.summaryReliefStatus === 2) {
							eeName = t('workPlanView.employee.unassigned');
						}

						employeeCell = <React.Fragment>
							<div style={{ fontSize: 12, fontWeight: shiftLine.isOwner ? 'bold' : '', paddingLeft: !shiftLine.isOwner && shiftLine.reliefId !== null ? 15 : '' }}>
								{shiftLine.employeeId ? this.genEmployeeDataviewToolTip(<div>{eeName}</div>, shiftLine.employeeId, eeName) : eeName}
							</div>
							<div style={{ fontSize: 10, display: 'flex' }}>
								{<div style={{ marginRight: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: !shiftLine.isOwner && shiftLine.reliefId !== null ? 15 : '' }}>
									{shiftLine.states !== null
										? this.genListStatus(shiftLine.states, currentRelief && shiftLine.states.find(x => x.isCurrent) ? shiftLine.states.find(x => x.isCurrent).label : undefined)
										: this.chipStatus(undefined)}
								</div>}
								{shiftLine.startDate === null ? '' :  DateFormatService.formatDateOrEmpty(shiftLine.startDate, UkgDateFormat.LongDate)}
								{shiftLine.startDate === null ? '' : <FontAwesomeIcon className={classes.iconLongArrowRight} icon={faLongArrowRight} />}
								{evalForeverDateToString(shiftLine.endDate, this.props.t)}
								{shiftLine.isOwner ? owner : ''}
							</div>
						</React.Fragment >
					} else {
						let currentRelief = false;

						if (shiftLine.startDate === null) {
							currentRelief = moment().isAfter(moment(shiftLine.endDate.substring(0, 10)));
						} else {
							currentRelief = moment().isBetween(
								moment(shiftLine.startDate.substring(0, 10)),
								moment(shiftLine.endDate.substring(0, 10)),
								'd', '[]'
							);
						}

						let eeName = genEmployeeName(shiftLine.employeeName, shiftLine.isTransfer);
						if (shiftLine.summaryReliefStatus === 0) {
							eeName = shiftLine.schedulePatternName
						} else if (shiftLine.summaryReliefStatus === 2) {
							eeName = t('workPlanView.employee.unassigned')
						}
						employeeCell = <React.Fragment>
							<div style={{ fontSize: 12, fontWeight: shiftLine.isOwner ? 'bold' : '' }}>
								{shiftLine.employeeId ? this.genEmployeeDataviewToolTip(<div>{eeName}</div>, shiftLine.employeeId, eeName) : eeName}
							</div>
							<div style={{ fontSize: 10, display: 'flex' }}>
								{<div style={{ marginRight: 4 }}>{this.chipStatus((shiftLine.employeeName === "Unassigned" || !currentRelief) ? undefined : shiftLine.sumSummaryReliefStatusLabel)}</div>}
								{shiftLine.startDate === null ? '' : DateFormatService.formatDateOrEmpty(shiftLine.startDate, UkgDateFormat.LongDate)}
								{shiftLine.startDate === null ? '' : <FontAwesomeIcon className={classes.iconLongArrowRight} icon={faLongArrowRight} />}
								{evalForeverDateToString(shiftLine.endDate, this.props.t)}
							</div>
						</React.Fragment>
					}
				}
			}
		}

		let sl = selectedWorkPlan.shiftLines.find(sl => sl.shiftLineId === shiftLine.parentId);
		const isEmployeeStopped = isShiftlineEmployeeStopped(shiftLine);
		const isHideActionButtons = editMode || exists(sl) || selectedWorkPlan.currentStatus.value === WorkplanCurrentStatus.Stopped
			|| selectedWorkPlan.isLocked || shiftLine.isDisabled;
		const isAsyncTaskProcessing = getIsAsyncTaskProcessing(selectedWorkPlan);
		let menuEmployeeActions = isHideActionButtons
			? ''
			: (<div className="buttonLineActions">
				<EmployeeOptionsMenu
					marginTop={marginTop}
					shiftLine={(shiftLine.type === 'relief' && shiftLine.isOwner) ? sl : shiftLine}
					shiftLineOwner={shiftLine.parentId ? shiftLine : shiftLine.currentOwner}
					anchorRef={refDivEE}
					isEmployeeStopped={isEmployeeStopped}
					isAsyncTaskProcessing={isAsyncTaskProcessing}
					handleEmployeeActions={this.handleEmployeeActions}
					buttonIcon={<FontAwesomeIcon className={classes.iconButton} icon={faEllipsisH} />}
				/>
			</div>);

		return (
			<div style={{ width: '100%' }} className={exists(shiftLine.parentId) ? classes.divRelief : ''} >
				<div className={clsx(classes.actionCellEE, classes.actionCell, shiftLine.type === 'relief' ? classes.actionCellRelief : '')} ref={refDivEE}>
					{employeeCell}
					{menuEmployeeActions}
				</div>
			</div >
		)
	}

	genEmployeeDataviewToolTip = (jsx, employeeId, employeeName) => {
		const { dataviewData, dataviewColumns } = this.props;

		let employeeDataview = dataviewData.filter(row => row[employeeId])

		if (employeeDataview.length === 0) {
			return jsx
		}

		let formattedEmployeeDataview = [];
		for (let row of employeeDataview) {
			for (let attribute of row[employeeId].attributes) {
				if (!formattedEmployeeDataview.find(x => x.key === attribute.key && x.value === attribute.value)) {
					formattedEmployeeDataview.push(attribute)
				}
			}
		}

		return <EmployeeDataviewTooltip jsx={jsx} listCol={dataviewColumns} data={formattedEmployeeDataview} employeeName={employeeName} />
	}

	genSchedulePatternNameCell = (workplan, shiftLine, editMode, onSave) => {
		const { classes, selectedWorkPlan } = this.props;
		let refDivSP = createRef();
		let period = '';

		if (shiftLine.type !== 'item') {
			return '';
		}

		if (!shiftLine.IsNew) {
			if (!exists(shiftLine.currentStatus) || shiftLine.currentStatus.effectiveDate === 0) {
				period = <div style={{ display: 'flex', fontSize: 10 }}>
					<div style={{ height: 10, marginRight: 4, paddingTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						{
							(shiftLine.states && shiftLine.states.length > 0)
								? this.genListStatus(shiftLine.states, shiftLine.currentStatus.label)
								: this.chipStatus(exists(shiftLine.currentStatus) ? shiftLine.currentStatus.label : undefined)
						}
					</div>
					{this.props.t(`workPlanView.status.${shiftLine.currentStatus.label}`)}
				</div>
			} else {
				let enddate = shiftLine.currentStatus.endDate;
				period = <div style={{ display: 'flex', fontSize: 10 }}>
					<div style={{ height: 10, marginRight: 4, paddingTop: 1 }}>
						{
							(shiftLine.states !== null && shiftLine.states.length > 0)
								? this.genListStatus(shiftLine.states, shiftLine.currentStatus.label)
								: this.chipStatus(exists(shiftLine.currentStatus) ? shiftLine.currentStatus.label : undefined)
						}
					</div>
					{DateFormatService.formatDateOrEmpty(shiftLine.currentStatus.effectiveDate, UkgDateFormat.LongDate)}
					{shiftLine.currentStatus.status === 2 ? '' : <FontAwesomeIcon className={classes.iconArrowPeriod} icon={faLongArrowRight} />}
					{evalForeverDateToString(enddate, this.props.t)}
				</div>
			}
		} else {
			if (shiftLine.effectiveDate !== null) {
				let enddate = shiftLine.endDate;
				period = <div style={{ display: 'flex', fontSize: 10 }}>
					<div style={{ height: 10, marginRight: 4, paddingTop: 1 }}>
						{this.chipStatus('Active')}
					</div>
					{DateFormatService.formatDateOrEmpty(shiftLine.effectiveDate, UkgDateFormat.LongDate)}
					<FontAwesomeIcon className={classes.iconArrowPeriod} icon={faLongArrowRight} />
					{evalForeverDateToString(enddate, this.props.t)}
				</div>
			}
		}

		const isAsyncTaskProcessing = getIsAsyncTaskProcessing(selectedWorkPlan);
		let shiftLineOptionsMenu = workplan.states.length === 0 || workplan.isLocked || shiftLine.isDisabled
			? ''
			: (<div className="buttonLineActions">
				<ShiftLineOptionsMenu
					anchorRef={refDivSP}
					handleShiftLineActions={this.handleShiftLineActions}
					shiftLineData={shiftLine}
					isAsyncTaskProcessing={isAsyncTaskProcessing}
					buttonIcon={<FontAwesomeIcon className={classes.iconButton} icon={faEllipsisH} />}
				/>
			</div>);

		if (shiftLine.editMode) {
			const shiftline = workplan.shiftLines.find((x) => x.shiftLineId === shiftLine.shiftLineId);
			return (
				<div>
					<TextField
						key={`spName${shiftLine.lineId}`}
						defaultValue={shiftLine.schedulePatternName}
						InputProps={{
							classes: {
								root: classes.schedulePatternNameInputRoot,
								input: classes.schedulePatternNameInput
							}
						}}
						InputLabelProps={{
							classes: {
								root: classes.labelRoot
							}
						}}
						error={shiftLine.emptySchedulePatternName && onSave}
						variant="outlined"
						labelWidth={0}
						onClick={() => this.setState({ disableToolbar: true })}
						onBlur={(event) => {
							this.handleChangeShiftLineSchedulePatternName(event.target.value, shiftline)
						}}
						autoComplete='off'
					/>
					{period}
				</div>
			)
		} else {
			return (
				<div className={classes.actionCell} ref={refDivSP} >
					<div className={classes.divActionCellLabel}>
						{/* TODO: Karim 2025/11/24 - this comes directly from the backend. We need to translate it	*/}
						<div>{shiftLine.schedulePatternName}</div>
						{period}
					</div>

					{editMode || shiftLine.currentStatus.status === 2 ? '' : shiftLineOptionsMenu}
				</div>
			)
		}

	}

	genOrgPathCell = (shiftLine, onSave) => {
		const { classes, selectedWorkPlan } = this.props;
		const selectedShiftline = selectedWorkPlan.shiftLines.find((x) => x.shiftLineId === shiftLine.shiftLineId);

		if (shiftLine.editMode) {
			const customSingleValue = ({ data }) => {
				return <div><CustomToolTip titletext={data.label} jsx={<div className={classes.location}>{data.label}</div>} /></div>
			};
			return (
				<ReactSelect
					selectClass={classes.select}
					placeholder={"Select Job"}
					value={shiftLine.job}
					options={selectedWorkPlan.jobs}
					error={(shiftLine.job === '' || shiftLine.job === null) && onSave}
					onChange={(event, value) =>
						this.handleChangeShiftLineJob(value, selectedShiftline.lineId)
					}
					// formatOptionLabel={customSingleValue}
					autoComplete='off'
					components={{
						SingleValue: customSingleValue,
						// Option: customOption
					}}
					styles={(shiftLine.job === '' || shiftLine.job === null) && onSave ? customSelectStylesTdError : customSelectStylesTd}
				/>
			)
		} else {
			return (shiftLine.job === '' || shiftLine.job === null ? '' : <CustomToolTip titletext={shiftLine.job.label} jsx={<div className={classes.location}>{shiftLine.job.label}</div>} />)
			// displayOrgpath(shiftLine.job.label, classes))
		}
	}

	handleSelectLine = async (rowData) => {
		const { selectedWorkPlan, updateSelectAllShiftLines } = this.props;
		const { editMode } = this.state;

		let workplan = Object.assign({}, selectedWorkPlan);

		let selectedShiftLine = workplan.shiftLines.find((x) => x.shiftLineId === rowData.shiftLineId);
		selectedShiftLine.checked = !selectedShiftLine.checked;

		let allLinesSelected = true;
		let selectedShiftlines = workplan.shiftLines.filter(x => x.type !== 'relief' && !this.isLineNotSelectable(x) && !x.checked); //CB: is actually the unselected shiftlines 
		if (exists(selectedShiftlines) && selectedShiftlines.length !== 0) {
			allLinesSelected = false;
		}

		let columns = await this.genColumns(workplan, editMode, false, allLinesSelected);
		if (allLinesSelected || selectedShiftlines.length === 1) { //CB: I think the <|| selectedShiftlines.length === 1> is unnecessary
			updateSelectAllShiftLines({ selectedWorkPlan: workplan, checkedAll: allLinesSelected, columns });
		}

		this.setState({ selectedShiftLines: workplan.shiftLines.filter(line => line.checked).length, checkedAll: allLinesSelected })
	}

	handleCheckAll = async () => {
		const { updateSelectAllShiftLines, selectedWorkPlan } = this.props;
		const { editMode, checkedAll } = this.state;
		let workplan = Object.assign({}, selectedWorkPlan);

		let selectedShiftLines = 0;
		for (let line of workplan.shiftLines) {
			if (!this.isLineNotSelectable(line)) {
				line.checked = !checkedAll;
				selectedShiftLines++;
			}
		}

		let columns = this.genColumns(workplan, editMode, false, !checkedAll);
		updateSelectAllShiftLines({ selectedWorkPlan: workplan, checkedAll: !checkedAll, columns });
		this.setState({ selectedShiftLines, checkedAll: !checkedAll })
	}

	isLineNotSelectable = (shiftline) => {
		const { selectedWorkPlan } = this.props;
		return (this.state.editMode && !shiftline.editMode)
			|| shiftline.isDisabled
			|| (exists(shiftline.reliefs) && shiftline.reliefs.length !== 0)
			|| shiftline.type === 'zone'
			|| (exists(shiftline.owners) && shiftline.owners.length !== 0 && selectedWorkPlan.status === WorkplanStatus.Played);
	}

	genLeftColumns = (workplan, editMode, onSave = false, checkedAll = false) => {
		const { dataviewData, dataviewColumns, classes, selectedWorkPlan } = this.props;
		let selectedShiftLines = workplan.shiftLines.filter(line => line.checked && !line.markedForDeletion).length;
		let firstColumn = <div style={{ display: 'flex' }}>
			<CustomToolTip enterDelay={500} leaveDelay={500} titletext={!selectedWorkPlan.isLocked ? this.props.t('table.selectAll') : ''}
				jsx={<div style={{ paddingRight: 6 }}>
					<FontAwesomeIcon
						style={{
							cursor: selectedWorkPlan.isLocked ? 'default' : 'pointer',
							backgroundColor: checkedAll ? '#1a518a' : 'white',
							color: checkedAll ? 'white' : (selectedWorkPlan.isLocked ? '#dedede' : '#0000008a'),
							marginRight: 6
						}}
						icon={checkedAll ? faCheck : faSquare}
						onClick={() => !selectedWorkPlan.isLocked ? this.handleCheckAll() : ''}
					/>
				</div>}
			/>
			{!editMode ? '' : <CustomToolTip enterDelay={500} leaveDelay={500} titletext={this.props.t('workPlanView.table.deleteSelectedLines')}
				jsx={<div onClick={(e) => selectedShiftLines > 0 ? this.handleToggleAction('deleteLines') : ''}>
					<FontAwesomeIcon style={{
						cursor: selectedShiftLines > 0 ? 'pointer' : '',
						color: selectedShiftLines > 0 ? '#1a518a' : '#bdbdbd'
					}} icon={faTrash} />
				</div>} />}
		</div>

		let columns = [];
		columns.push({
			title: '',
			field: 'emptyColumn',
			flexGrow: 1,
			minWidth: 40
		})
		if (!editMode) {

			columns.push({
				title: '#',
				field: "lineId",
				flexGrow: 1,
				minWidth: 30,
				render: (rowData) => {
					return rowData.type !== 'item' ? ''
						: <div id={rowData.shiftLineId}>{rowData.lineId + 1}</div>
				}
			})
		}
		columns.push({
			title: firstColumn,
			field: "checked",
			minWidth: 60,
			flexGrow: 1,
			cellStyle: { paddingTop: 0, paddingBottom: 0 },
			render: (rowData) => {
				let lineNotSelectable = this.isLineNotSelectable(rowData) || selectedWorkPlan.isLocked;
				return rowData.type !== 'item' || (editMode && !rowData.editMode) ? ''
					: <FontAwesomeIcon
						style={{
							cursor: lineNotSelectable ? 'default' : 'pointer',
							color: rowData.checked ? 'white' : (lineNotSelectable ? '#dedede' : '#0000008a'),
							backgroundColor: rowData.checked ? '#1a518a' : 'white'
						}}
						icon={rowData.checked ? faCheck : faSquare}
						onClick={() => !lineNotSelectable ? this.handleSelectLine(rowData) : ''}
					/>
			}
		})
		columns.push({
			title: this.props.t('workPlanView.columns.employee'),
			field: "employeeFullName",
			minWidth: 250,
			flexGrow: 5,
			cellStyle: { paddingTop: 0, paddingBottom: 0 },
			render: (rowData) => { return rowData.type === 'zone' ? '' : this.genEmployeeCell(rowData, editMode) }
		})

		for (const col of dataviewColumns) {
			if (col.visible) {
				columns.push({
					title: col.label,
					field: col.key,
					minWidth: 180,
					flexGrow: 4,
					render: rowData => {
						return (!rowData.currentOwner || rowData.currentOwner.employeeId === '' || !exists(dataviewData.find((x) => x[rowData.currentOwner.employeeId])) || !exists(dataviewData.find((x) => x[rowData.currentOwner.employeeId])[rowData.currentOwner.employeeId]["attributes"].find(x => x.key === col.key)))
							? ''
							: formatDataviewData(dataviewData.find((x) => x[rowData.currentOwner.employeeId])[rowData.currentOwner.employeeId]["attributes"].find(x => x.key === col.key).value, col.dataValueType, classes)
					}
				})
			}
		}

		columns.push({
			title: this.props.t('workPlanView.columns.shiftline'),
			field: "schedulePatternName",
			minWidth: 240,
			flexGrow: 4,
			render: (rowData) => {

				if (rowData.parentId && rowData.summaryReliefStatus === 0) {
					return this.props.t('workPlanView.shiftlineStatus.pausedLine');
				}
				if (rowData.parentId && rowData.summaryReliefStatus === 2) {
					return this.props.t('workPlanView.shiftlineStatus.stoppedLine');
				}
				return this.genSchedulePatternNameCell(workplan, rowData, editMode, onSave);
			}
		})

		columns.push({
			title: this.props.t('workPlanView.columns.jobs'),
			field: "orgPath",
			minWidth: 200,
			flexGrow: 4,
			render: rowData => {
				return rowData.type !== 'item' ?
					(
						rowData.type === 'relief'
							? ''
							: <div className={exists(rowData.parentId) ? classes.divRelief : ''}>
								<CustomToolTip titletext={rowData.label} jsx={<div className={exists(rowData.parentId) ? classes.locationJob : classes.location}>{rowData.label}</div>} />
							</div>
					)
					: this.genOrgPathCell(rowData, onSave)
			}
		})

		return columns;
	}

	handleChangeShiftLineSchedulePatternName = async (value, shiftline) => {
		const { selectedWorkPlan, updateSelectedWorkPlan } = this.props;

		let workplan = cloneDeep(selectedWorkPlan);

		let selectedShiftline = workplan.shiftLines.find((x) => x.shiftLineId === shiftline.shiftLineId)
		selectedShiftline.schedulePatternName = value;
		await updateSelectedWorkPlan(workplan);
		this.setState({ disableToolbar: false })
	}

	handleChangeShiftLineJob = (value, lineId) => {
		const { selectedWorkPlan, updateSelectedWorkPlan, settingsList } = this.props;

		let workplan = { ...selectedWorkPlan };
		const shiftline = workplan.shiftLines.find((x) => x.lineId === lineId);

		if (!shiftline) {
			return;
		}
		shiftline.job = value;
		const workplanSettings = settingsList.find((setting) => setting.id === selectedWorkPlan.adminSettingId) || {};
		const enableSystemCoverage = workplanSettings.content.coverage.enableSystemCoverage;
		workplan.quotas = genQuotas(workplan, enableSystemCoverage);
		updateSelectedWorkPlan(workplan);
		// this.setState({fixedColumnsLeft: 12 });
	}

	chipStatus = (state = '', tag = false, rightIcon = '', alt = '') => {
		const { t } = this.props;
		let color = '';

		switch (state) {
			case 'Active':
			case 'UnAssign':
				color = 'green';
				break;
			case 'Scheduled':
				color = 'blue';
				break;
			case 'PausedLine':
				color = 'yellow'
				alt = 'Alt'
				break
			case 'Paused':
			case 'NotCovered':
				color = 'yellow';
				break;
			case 'Stopped':
				color = 'red';
				break;
			default:
				color = 'white';
		}

		return (
			<ChipTagStatus
				color={color + alt}
				label={tag && state ? t(`workPlanView.status.${state}`) : ''}
				rightIcon={rightIcon}
			/>
		);
	}

	genDaysFromPatternTemplate = (patternTemplate) => {
		let days = {};

		for (const item of patternTemplate.items) {
			if (!exists(days['day' + item.day])) {
				days['day' + item.day] = [];
			}
			if (item.shiftTemplate !== null) {
				days['day' + item.day].push(item.shiftTemplate);
			} else if (item.payCodeEditTemplate !== null) {
				days['day' + item.day].push(item.payCodeEditTemplate);
			}
		}

		return days;
	}

	addShiftLines = async (schedulePattern, job = '', Repetition, effectiveDate, endDate) => {
		const { selectedWorkPlan, updateSelectedWorkPlan, updateManageShiftLines, updateTableColumns, settingsList } = this.props;
		const { checkedAll } = this.state;
		let workplan = Object.assign({}, selectedWorkPlan);
		let newLines = [];

		let pattern = (schedulePattern === '' || schedulePattern === null) ? '' : await this.getSchedulePattern(schedulePattern.value);
		let nbLines = selectedWorkPlan.shiftLines.length;

		for (let i = 0; i < Repetition; i++) {
			let newLine = {
				id: `${i}`,
				schedulePatternName: pattern === '' ? '' : pattern.label,
				job,
				tableData: { id: i + nbLines },
				IsNew: true,
				editMode: true,
				lineId: selectedWorkPlan.shiftLines.length + i + 1,
				paycodeTemplates: [],
				type: 'item',
				employeeId: '',
				states: [],
				effectiveDate,
				endDate,
				shiftLineId: `newLineId-${Math.random()}`,
				parentId: 'newLine',
				checked: false,
				summaryReliefs: []
			}

			if (pattern !== '') {
				newLine = { ...newLine, ...this.genDaysFromPatternTemplate(pattern) };
			}

			for (let j = 1; j <= selectedWorkPlan.nbDays; j++) {
				if (!exists(newLine['day' + j])) {
					newLine['day' + j] = [];
				}
			}

			newLine.maxItemsByDay = getShiftLineHeight(newLine, selectedWorkPlan);
			newLines.push(newLine);
		}
		workplan.shiftLines = [...newLines, ...workplan.shiftLines];

		const workplanSettings = settingsList.find((setting) => setting.id === selectedWorkPlan.adminSettingId) || {};
		const enableSystemCoverage = workplanSettings.content.coverage.enableSystemCoverage;
		workplan.quotas = await genQuotas(workplan, enableSystemCoverage);
		updateTableColumns(await this.genColumns(workplan, true, false, checkedAll));

		this.setState({
			editMode: true,
			selectedShiftLines: newLines.length
		});

		await updateSelectedWorkPlan(workplan);
		await updateManageShiftLines(true);
	}

	backToList = async () => {
		const { updateSpinnerShow, updateSelectedWorkPlan } = this.props;
		updateSpinnerShow(true);
		updateSelectedWorkPlan('')
	}

	handleChangeSelect = (target, value) => {
		this.setState({ [target]: value });
	}

	generateInputs = (placeholder, value, list, target, icon) => {
		const { classes } = this.props;
		const customSingleValue = ({ data }) => (
			<div className="input-select">
				<div className="input-select__single-value" style={{ display: 'flex', maxWidth: 138, whiteSpace: 'nowrap' }}>
					<FontAwesomeIcon className={classes.iconCustomSingleValue} icon={icon} />
					<div style={{ overflow: 'hidden' }}>{data.label}</div>
				</div>
			</div>
		);

		return (
			<ReactSelect
				placeholder={<React.Fragment><FontAwesomeIcon className={classes.iconButton} icon={icon} /> {placeholder}</React.Fragment>}
				value={typeof value !== 'undefined' ? value : ''}
				options={list}
				onChange={this.handleToggleAction}
				target={target}
				error={!isNull(value) && isNull(value.label)}
				components={{ SingleValue: customSingleValue }}
				className={classes.selectShiftLineEdit}
				styles={customSelectStyles}
			/>
		)
	}

	genAddShiftLinesMenu = () => {
		const { selectedWorkPlan, classes } = this.props;

		return <div style={{ display: 'flex' }}>
			<div className={classes.actionCell}>
				<AddShiftLinesMenu
					buttonIcon={<FontAwesomeIcon style={{ marginLeft: 10 }} color={'#0A54A2'} className={classes.iconButton} icon={faChevronDownSolid} />}
					orgpaths={selectedWorkPlan.jobs ? selectedWorkPlan.jobs.map(job => { return { value: job.nodeId, label: job.orgPath } }) : []}
					addShiftLines={this.addShiftLines}
					disableToolbar={this.state.disableToolbar}
					title={this.props.t('workPlanView.addShiftLines.title')}
				/>
			</div>
		</div>
	}

	checkLinesBeforeSave = () => {
		const { selectedWorkPlan, updateSelectedWorkPlan, updateSpinnerShow, updateTableColumns } = this.props;
		const { checkedAll } = this.state;
		let workplan = Object.assign({}, selectedWorkPlan);
		let hasError = false;

		for (let i = 0; i < workplan.shiftLines.length; i++) {
			if (workplan.shiftLines[i].IsNew && workplan.shiftLines[i].markedForDeletion) {
				workplan.shiftLines.splice(i, 1);
				i--;
			}
		}

		updateSpinnerShow(true);
		for (let shiftLine of workplan.shiftLines.entries()) {
			if (shiftLine.editMode) {
				shiftLine.emptySchedulePatternName = shiftLine.schedulePatternName === '';
				shiftLine.emptyJob = shiftLine.job === '';

				if (shiftLine.emptySchedulePatternName || shiftLine.emptyJob) {
					hasError = true;
				}
			}
		}

		if (hasError) {
			updateSelectedWorkPlan(workplan);
			updateTableColumns(this.genColumns(workplan, true, true, checkedAll));
		} else {
			this.handleSaveShiftLinesEdit();
		}
	}

	handleSaveShiftLinesEdit = async () => {
		const { selectedWorkPlan, updateManageShiftLines } = this.props;

		let customShiftLines = formatShiftLinesToSave(selectedWorkPlan);

		await axios.post(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/Workplan/EditShiftLines', { WorkplanId: selectedWorkPlan.workplanId, ShiftLines: customShiftLines }, currentHttpOptions())
			.then(response => {
				if (response.data.fail.length >= 1) {
					let message = "Complete with error : " + response.data.details[0].message;
					this.props.updateSnackbar({
						typeSnackbar: 'error',
						messageSnackbar: message,
						openSnackbar: true,
					})
				}
				else {
					this.getWorkplanDetails();
					this.getWorkplanWarnings();
					updateManageShiftLines(false);

					this.setState({
						editMode: false,
						checkedAll: false,
						selectedShiftLines: 0,
						enableCopy: false
					});
				}
			}).catch(ex => {
				let errorMessage = aux.handleAPIErrors(ex.response)
				this.props.updateSnackbar({
					typeSnackbar: 'error',
					messageSnackbar: errorMessage,
					openSnackbar: true,
				})
			})
	}

	handleCancelShiftLinesEdit = async () => {
		const { updateManageShiftLines } = this.props;
		this.getWorkplanDetails();
		updateManageShiftLines(false);
		this.setState({
			editMode: false,
			checkedAll: false,
			selectedShiftLines: 0,
			showCancelShiftLinesEdit: false
		});
	}

	handleDeleteShiftLines = async () => {
		const { selectedWorkPlan, updateSelectAllShiftLines } = this.props;

		let workplan = Object.assign({}, selectedWorkPlan);

		for (let sl of workplan.shiftLines) {
			if (sl.checked) {
				sl.markedForDeletion = true;
			}
		}

		workplan.shiftLines = workplan.shiftLines.filter(line => !(line.isNew && line.markedForDeletion));
		let columns = await this.genColumns(workplan, true, false, false);
		updateSelectAllShiftLines({ selectedWorkPlan: workplan, checkedAll: false, columns });

		this.setState({ selectedShiftLines: 0, showDeleteDialog: false, checkedAll: false });
	}

	clearMouseTooltip = () => {
		const { selectedPaycode, updateSelectedPaycode } = this.props;
		const { selectedSchedulePatternTemplate, selectedShiftTemplate } = this.state;

		if (selectedPaycode !== '' || selectedSchedulePatternTemplate !== '' || selectedShiftTemplate !== '') {
			if (selectedPaycode !== '') {
				updateSelectedPaycode('')
			}
			this.setState({
				isMouseTooltipVisible: '',
				selectedSchedulePatternTemplate: '',
				selectedShiftTemplate: ''
			});
		}
	}

	genToolBarEdit = () => {
		const { selectedPaycode, schedulePatternsTemplates, paycodeList, shiftTemplatesList, selectedWorkPlan, selectedWorkPlanInitial, classes, t } = this.props;
		const { selectedSchedulePatternTemplate, selectedShiftTemplate, enableCopy, enableDelete, disableToolbar } = this.state;

		let refSchedulePatternTemplate = createRef();
		let refShiftTemplate = createRef();
		let refPaycode = createRef();

		let nbEditModeLines = selectedWorkPlan.shiftLines.filter(line => line.editMode && !line.markedForDeletion).length;
		let disableSave = disableToolbar || JSON.stringify(selectedWorkPlanInitial) === JSON.stringify(selectedWorkPlan);
		return <React.Fragment>
			{this.genAddShiftLinesMenu()}
			<div ref={refSchedulePatternTemplate}>
				<CustomSelect disabled={nbEditModeLines === 0 || disableToolbar} title={t('workPlanView.templates.patternTemplate')} anchorRef={refSchedulePatternTemplate} data={schedulePatternsTemplates} icon={faCalendarAlt} selected={selectedSchedulePatternTemplate !== ''}
					updateSelected={(value) => this.handleToggleAction('selectedSchedulePatternTemplate', value)} clearTooltip={this.clearMouseTooltip} />
			</div>
			<div ref={refShiftTemplate} >
				<CustomSelect disabled={nbEditModeLines === 0 || disableToolbar} title={t('workPlanView.templates.shiftTemplate')} anchorRef={refShiftTemplate} data={shiftTemplatesList} icon={faCalendarDay} selected={selectedShiftTemplate !== '' && !enableCopy}
					updateSelected={(value) => this.handleToggleAction('selectedShiftTemplate', value)} clearTooltip={this.clearMouseTooltip} />
			</div>
			<div ref={refPaycode} >
				<CustomSelect disabled={nbEditModeLines === 0 || disableToolbar} title={t('workPlanView.templates.paycode')} anchorRef={refPaycode} data={paycodeList} icon={faUniversity} selected={selectedPaycode !== ''}
					updateSelected={(value) => this.handleToggleAction('selectedPaycode', value)} clearTooltip={this.clearMouseTooltip} />
			</div>

			{this.genButtonAction(this.handleToggleAction, faCopy, 'enableCopy', enableCopy, t('workPlanView.templates.copy'), nbEditModeLines === 0 || disableToolbar)}
			{this.genButtonAction(this.handleToggleAction, faEraser, 'enableDelete', enableDelete, t('workPlanView.templates.delete'), nbEditModeLines === 0 || disableToolbar)}

			<Button disabled={disableToolbar} className={clsx(classes.buttonEditShiftLineToolBar, classes.buttonCancelEdit)} style={{ paddingLeft: 7, marginLeft: 20 }} onClick={(e) => {
				if (JSON.stringify(selectedWorkPlanInitial) !== JSON.stringify(selectedWorkPlan)) {
					this.setState({ showCancelShiftLinesEdit: true });
					e.stopPropagation();
				} else {
					this.handleCancelShiftLinesEdit();
				}
			}}>
				{t('common:Action.cancel')}
			</Button>
			<Button disabled={disableSave}
				className={clsx(classes.buttonEditShiftLineToolBar, disableSave ? classes.buttonSaveChangesDisabled : classes.buttonSaveChanges)}
				style={{ paddingLeft: 9 }} onClick={(e) => {
					this.checkLinesBeforeSave();
					e.stopPropagation();
				}}>
				{t('common:Action.saveChanges')}
			</Button>
		</React.Fragment >
	}

	deleteShiftLine = (event, rowData) => {
		const { selectedWorkPlan, updateSelectedWorkPlan } = this.props;
		let workplan = Object.assign({}, selectedWorkPlan);
		let selectedShiftline = workplan.shiftLines.find((x) => x.shiftLineId === rowData.shiftLineId)

		if (exists(selectedShiftline.shiftLineId)) {
			selectedShiftline.MarkedForDeletion = true;
			workplan.deletedLines.push(selectedShiftline);
		}
		workplan.shiftLines.splice(selectedShiftline, 1);

		updateSelectedWorkPlan(workplan);
	}

	genListStatus = (states, currentState = '', tag = false) => {
		const { classes, t } = this.props;
		let htmlTooltip = '';
		let isIndirect = false;
		
		
		if (states.length > 0) {
			let auxHtmlTooltip = [];
			for (const [index, state] of states.entries()) {
				isIndirect = isStateIndirect(state)
				auxHtmlTooltip.push(<div className={classes.divStatus} key={index}>
					<div className={classes.chipStatusMargin}>{this.chipStatus(state.label, false, '', isIndirect ? 'Alt' : '')}</div>
					<div className={classes.divChipStatusLabel}>{t(`workPlanView.status.${state.label}`)}</div>
					{state.label !== 'Stopped' ? DateFormatService.formatDateOrEmpty(state.effectiveDate, UkgDateFormat.LongDate) : ""}
					{state.label !== 'Stopped' ? <FontAwesomeIcon className={classes.iconArrowPeriodTooltip} icon={faLongArrowRight} /> : ""}
					{evalForeverDateToString(state.endDate, t)}
					<br />
				</div>)
			}
			htmlTooltip = auxHtmlTooltip[0] === "" && auxHtmlTooltip.length === 1 ? '' : (<div>{auxHtmlTooltip}</div>);
		}

		return <CustomToolTip enterDelay={500} leaveDelay={500} titletext={htmlTooltip} jsx={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
			{!currentState || currentState === 'Draft' || currentState === 'Scheduled'
				? this.chipStatus(currentState)
				: this.chipStatus(currentState, tag, '', (currentState !== 'Active' && isIndirect) ? 'Alt' : '')}
		</div>} />;
	}

	genLockedTooltipLabel = () => {
		const { selectedWorkPlan } = this.props;

		if (!selectedWorkPlan.isLocked) {
			return '';
		}

		let lockedBy;

		switch (selectedWorkPlan.lockedBy) {
			case 'BidProfile':
				lockedBy = 'Shift Bid';
				break;
			default:
				lockedBy = 'Unspecified';
				break;
		}

		return `Workplan is currently locked by ${lockedBy} ${selectedWorkPlan.lockedByValue || ''}`;
	}

	handleChangeLimit = dataKey => {
		this.setState({ limit: dataKey, page: 1 })
	};

	handleChangePage = page => {
		this.setState({ page: page })
	};

	handleDownloadExcelTemplate = async () => {
		//GetExcelTemplate
		const { selectedWorkPlan } = this.props
		let response = await axios.get(`${process.env.REACT_APP_DOTNET_URL}/api/v1/manager/workplan/GetExcelTemplate/${selectedWorkPlan.workplanId}`, {
			headers: {
				'Content-Type': 'blob',
				Authorization: "Bearer " + sessionStorage.getItem('authToken')
			},
			responseType: 'arraybuffer',
		});
		const url = window.URL.createObjectURL(new Blob([response.data]));
		let link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', `${selectedWorkPlan.name.replace(' ', '_')}_ShiftLinesUploadTemplate.xlsx`); //or any other extension
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	handleDownloadWorkplanTemplateReport = async () => {
		//GetExcelTemplate
		const { selectedWorkPlan } = this.props
		let response = await axios.get(`${process.env.REACT_APP_DOTNET_URL}/api/v1/manager/workplan/GetWorkplanTemplateReport/${selectedWorkPlan.workplanId}`, {
			headers: {
				'Content-Type': 'blob',
				Authorization: "Bearer " + sessionStorage.getItem('authToken')
			},
			responseType: 'arraybuffer',
		});
		const url = window.URL.createObjectURL(new Blob([response.data]));
		let link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', `${selectedWorkPlan.name.replace(' ', '_')}_WorkplanTemplateReport.xlsx`); //or any other extension
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	handleRefreshTaskProgression = (selectedWorkPlan) => {
		const { updateWorkplanAsyncTaskProgress, updateSnackbar, t } = this.props
		axios.get(`${process.env.REACT_APP_DOTNET_URL}/api/v1/manager/Workplan/${selectedWorkPlan.workplanId}/GetTaskProgression/${getAsyncTaskType(selectedWorkPlan)}`, currentHttpOptions())
			.then((result) => {
				if (result.data.isCompleted) {
					updateWorkplanAsyncTaskProgress({
						isStopping: false,
						isPausing: false,
						isRollingOut: false,
					});
					this.getWorkplanDetailsAndWarnings();
					updateSnackbar({
						typeSnackbar: 'success',
						messageSnackbar: getAsyncTaskSuccessLabel(selectedWorkPlan, t),
						openSnackbar: true,
					})
				}
			})
			.catch((err) => {
				// TODO Unsure what to do for now
			});
	}
	componentDidUpdate() {
		const { selectedWorkPlan } = this.props;
		const isAsyncTaskProcessing = getIsAsyncTaskProcessing(selectedWorkPlan);
		
		if (isAsyncTaskProcessing && this.taskProgressionInterval.current === null) {
			this.taskProgressionInterval.current = setInterval(() => {
				this.handleRefreshTaskProgression(selectedWorkPlan);
			}, 5000);
		}
		else if (!isAsyncTaskProcessing && this.taskProgressionInterval.current !== null) {
			clearInterval(this.taskProgressionInterval.current);
			this.taskProgressionInterval.current = null;
		}
	}

	render() {
		const { selectedWorkPlan, snackbar, classes, accessProfiles, settingsList, t } = this.props;
		const { displayDialog, editMode, showDeleteDialog, workplanActionOptions, employeeList, formTitle, displayQuota, isMouseTooltipVisible,
			mouseTooltip, showCancelShiftLinesEdit, disableToolbar, height, columns, limit, page } = this.state;

		let snackBar = snackbar.openSnackbar ? (
			<Snackbar
				type={snackbar.typeSnackbar}
				message={snackbar.messageSnackbar}
				open={snackbar.openSnackbar}
				closeSnackbar={this.closeSnackbar}
				isNoAutoHideSnackbar={snackbar.isNoAutoHideSnackbar}
				bodyStyle={{ whiteSpace: 'pre-line' }}
			/>) : '';

		let workplanSetting = settingsList.find((setting) => setting.id === selectedWorkPlan.adminSettingId);

		let infoWorkplan = (!exists(selectedWorkPlan) || Object.keys(selectedWorkPlan).length === 0) ? '' : <div>
			<span className={classes.workplanName}>{selectedWorkPlan.name}</span>
			{selectedWorkPlan.description !== '' ? <React.Fragment>
				<Typography className={classes.dateTypo}> {this.props.t('workPlanView.details.description')} </Typography>
				<div className={classes.divValueWorkplanDetails}>{selectedWorkPlan.description}</div>
			</React.Fragment> : ''}
			{selectedWorkPlan.states.length > 0 ? <React.Fragment>
				<Typography className={classes.dateTypo}> {this.props.t('workPlanView.details.period')} </Typography>
				<div className={classes.divValueWorkplanDetails}>
					{DateFormatService.formatDateOrEmpty(selectedWorkPlan.startDate, UkgDateFormat.LongDate)}
					<FontAwesomeIcon className={classes.iconArrowPeriodTooltip} icon={faLongArrowRight} />
					{evalForeverDateToString(selectedWorkPlan.endDate, this.props.t)}
				</div>
			</React.Fragment> : ''}

			{selectedWorkPlan.states !== null && selectedWorkPlan.states.length === 0 ? '' :
				<React.Fragment>
					<Typography className={classes.dateTypo}> {this.props.t('workPlanView.details.states')} </Typography>
					{
						<div className={classes.divValueWorkplanDetails}>
							{selectedWorkPlan.states === null ? '' : selectedWorkPlan.states.map((state, index) => {
								return <div className={classes.divStatus} key={index}>
									<div className={classes.chipStatusMargin}>{this.chipStatus(state.label)}</div>
									<div className={classes.divChipStatusLabel}>{this.props.t(`workPlanView.status.${state.label}`)}</div>
									{state.label !== 'Stopped' ? DateFormatService.formatDateOrEmpty(state.effectiveDate, UkgDateFormat.LongDate) : ""}
									{state.label !== 'Stopped' ? <FontAwesomeIcon className={classes.iconArrowPeriodTooltip} icon={faLongArrowRight} /> : ""}
									{evalForeverDateToString(state.endDate, this.props.t)}
									<br />
								</div>
							})}
						</div>
					}
				</React.Fragment>
			}

			{selectedWorkPlan.note !== null ? <React.Fragment>
				<Typography className={classes.dateTypo}> {'Note'} </Typography>
				<div className={classes.divValueWorkplanDetails}>{selectedWorkPlan.note}</div>
			</React.Fragment> : ''}
			<React.Fragment>
				<Typography className={classes.dateTypo}> {t('workPlanView.columns.jobs')} </Typography>
				<div className={classes.divValueWorkplanDetails}>{selectedWorkPlan.jobs.map((job, index) => { return <Typography key={"jobOrgPathKey__" + index}>{displayOrgpath(exists(job.orgPath) ? job.orgPath : job.label, classes, false)}</Typography> })}</div>
			</React.Fragment>
		</div>

		const isAsyncTaskProcessing = getIsAsyncTaskProcessing(selectedWorkPlan);
		const isManageShifLinesDisabled = selectedWorkPlan.isLocked || !accessProfiles.manageShiftlines || isAsyncTaskProcessing;

		return (
			<div style={{ position: 'relative' }}>
				{
					(editMode)
					? (<div className={classes.editHeader}>{this.props.t('workPlanView.global.editMode')}</div>)
					: (<div className={classes.calendarHeader}>
						<Button onClick={(e) => {
							this.backToList();
							e.stopPropagation();
						}}>
							<FontAwesomeIcon className={classes.icon} icon={faArrowLeft} />
						</Button>
						<span className={classes.workplanName}>{selectedWorkPlan.name}</span>
						<div className={classes.calendarHeaderStatus}>
							{exists(selectedWorkPlan.currentStatus) ? this.chipStatus(selectedWorkPlan.currentStatus.label, true) : ''}
						</div>
						<CustomToolTip
							enterDelay={500}
							placement="right-start"
							leaveDelay={500}
							titletext={infoWorkplan}
							jsx={
								<div className={classes.calendarHeaderStatusInfo}>
									{<FontAwesomeIcon 
										size="2x"
										className={classes.iconInfoWorkplan}
										icon={faInfoCircle}
									/>}
								</div>
							}
						/>
						<WorkplanWarnings workplanSetting={workplanSetting} />
						<div className={classes.workplanSplitButton}>
							<WorkplanActionOptions
								options={workplanActionOptions}
								disabled={editMode || selectedWorkPlan.isLocked}
								classes={classes}
							/>
						</div>
					</div>)
				}
				<div>
					<div className={classes.tableToolbar}>
						{
							(!editMode)
							? (<div key="manage-shiftlines">
								<CustomButton
									className={isManageShifLinesDisabled
										? classes.buttonEditShiftLineToolBarDisabled
										: classes.buttonEditShiftLineToolBar}
									onClick={(e) => {
										this.handleToggleAction('manageShiftLines');
										e.stopPropagation();
									}}
									disabled={isManageShifLinesDisabled}
									tooltip={selectedWorkPlan.isLocked ? this.genLockedTooltipLabel() : ''}
								>
									{selectedWorkPlan.isLocked ? <LockIcon /> : <FontAwesomeIcon className={classes.icon} icon={faPen} />}
									<div style={{ paddingLeft: 4 }}>{t('workPlanView.table.manageShiftlines')}</div>
								</CustomButton>
							</div>)
							: (this.genToolBarEdit())
						}
						<div className={classes.tableToolbarRight}>
							{
								(!editMode 
									&& selectedWorkPlan.currentStatus.value === WorkplanCurrentStatus.Scheduled 
									&& !selectedWorkPlan.isLocked 
									&& selectedWorkPlan.coverage
									&& [PlanTypes.plan, PlanTypes.budget].includes(selectedWorkPlan.coverage.pushCoverageRolloutWorkplan)
									&& selectedWorkPlan.states.every((state) => state.status !== StateStatus.Paused))
								&& ( <ReloadCoverageButton getWorkplanDetails={this.getWorkplanDetails}/> )
							}
							{
								(!editMode && selectedWorkPlan.isImportEnabled && !selectedWorkPlan.isLocked)
								&& (
									<>
										<UploadExcel
											key="upload-excel-component"
											refreshWorkplan={this.getWorkplanDetailsAndWarnings}
											isImportingExcelAsync={selectedWorkPlan.isImportingExcel}
											disableToolbar={disableToolbar || !accessProfiles.manageShiftlines || isAsyncTaskProcessing}
										/>
										<CustomToolTip
											key="download-excel-tooltip"
											enterDelay={500}
											placement="right-start"
											leaveDelay={500}
											titletext={t('workPlanView.table.downloadExcel')}
											jsx={
												<div 
													className={clsx(classes.tableColumnButton, (disableToolbar || isAsyncTaskProcessing) ? classes.disabledButton : '')} 
													onClick={(e) => {
														!isAsyncTaskProcessing && this.handleDownloadExcelTemplate();
														e.stopPropagation();
													}}
												>
													<FontAwesomeIcon icon={faFileDownload} />
												</div>
											}
										/>
									</>
								)
							}
							<CustomToolTip
								key="workload-counts-tooltip"
								enterDelay={500}
								placement="right-start"
								leaveDelay={500}
								titletext={displayQuota ? t('workPlanView.table.hideWorkloadCounts') : t('workPlanView.table.showWorkloadCounts')}
								jsx={
									<div className={clsx(classes.tableColumnButton, (disableToolbar || isAsyncTaskProcessing) ? classes.disabledButton : '')} onClick={(e) => {
										!isAsyncTaskProcessing && this.handleToggleAction('displayQuota'); e.stopPropagation();
									}}>
										<FontAwesomeIcon transform={{ rotate: 180 }} icon={faWindowMaximize} />
									</div>
								}
							/>
							<ColumnsManager
								key="columns-manager-component"
								genColumns={this.genColumns}
								disableToolbar={disableToolbar || isAsyncTaskProcessing}
							/>
							<CustomToolTip
								key="workload-counts-tooltip-2"
								enterDelay={500}
								placement="right-start"
								leaveDelay={500}
								titletext={t('workPlanView.table.reports.title')}
								jsx={
									<div>
										<GroupedIconButton
											icon={(
												<FontAwesomeIcon icon={faClipboard} size="xs" style={{paddingLeft: '1px', paddingTop: '1px'}} />
											)}
											buttonClassName={classes.tableColumnButton}
											options={[
												{
													value: "WorkplanTemplateReport",
													label: t('workPlanView.table.reports.workplanTemplateReport'),
													action: () => { this.handleDownloadWorkplanTemplateReport(); },
													disabled: false,
												},
											]}
										/>
									</div>
								}
							/>
						</div>
					</div>
					<WorkplanShiftlineTable
						classes={classes}
						selectedWorkPlan={selectedWorkPlan}
						editMode={editMode}
						columns={columns}
						height={height}
						limit={limit}
						page={page}
						handleChangePage={this.handleChangePage}
						handleChangeLimit={this.handleChangeLimit}
					/>
				</div>
				<WorkplanQuotaTable
					classes={classes}
					selectedWorkPlan={selectedWorkPlan}
					displayQuota={displayQuota}
					columns={columns}
					height={height}
				/>

				{snackBar}
				<Dialog
					open={displayDialog}
					title={t('workPlan.coverage.warningTitle')}
					contentText={t('workPlan.coverage.warningText')}
					submit={this.pushCoverage}
					submitText={t('workPlan.coverage.accept')}
					cancelText={t('workPlan.coverage.cancel')}
					cancel={() => { this.displayDialog(false) }}
				/>
				<SimpleDialog
					open={showDeleteDialog}
					title={t('common:Dialog.deleteShiftlines')}
					contentText={t('common:Dialog.deleteShiftlinesConfirm')}
					acceptText={t('workPlanList.yes')}
					rejectText={t('workPlanList.no')}
					submit={this.handleDeleteShiftLines}
					cancel={() => this.setState({ showDeleteDialog: false })}
				/>
				<SimpleDialog
					open={showCancelShiftLinesEdit}
					title={t('common:Dialog.cancelEdits')}
					contentText={t('common:Dialog.cancelEditsConfirm')}
					acceptText={t('workPlanList.yes')}
					rejectText={t('workPlanList.no')}
					submit={this.handleCancelShiftLinesEdit}
					cancel={() => this.setState({ showCancelShiftLinesEdit: false })}
				/>

				<ActionForm
					refreshWorkplan={this.getWorkplanDetailsAndWarnings}
					genQuotas={genQuotas}
					employeeList={employeeList}
					formTitle={formTitle}
				/>
				<MouseTooltip
					visible={isMouseTooltipVisible && mouseTooltip !== ''}
					offsetX={15}
					offsetY={10}
					style={{ backgroundColor: 'white', border: '1px solid', borderRadius: 4, padding: 4, zIndex: 12 }}
				>
					{mouseTooltip}
				</MouseTooltip>
			</div >
		)
	}
}

const mapStateToProps = state => {
	return {
		spinnerShow: state.spinnerShow,
		selectedWorkPlan: state.selectedWorkPlan,
		selectedWorkPlanInitial: state.selectedWorkPlanInitial,
		schedulePatternsTemplates: state.schedulePatternsTemplates,
		schedulePatternsTemplatesDetails: state.schedulePatternsTemplatesDetails,
		shiftTemplatesDetails: state.shiftTemplatesDetails,
		shiftTemplatesList: state.shiftTemplatesList,
		manageShiftLines: state.manageShiftLines,
		snackbar: state.snackbar,
		paycodeList: state.paycodeList,
		selectedPaycode: state.selectedPaycode,
		employeeList: state.employeeList,
		dataviewData: state.dataviewData,
		dataviewColumns: state.dataviewColumns,
		totalsColumns: state.totalsColumns,
		tableColumns: state.tableColumns,
		settingsList: state.settingsList,
		accessProfiles: state.accessProfiles,
	}
}

const mapDispatchToProps = {
	updateSpinnerShow,
	updateMAINworkPlans,
	updateSchedulePatternsTemplates,
	updateSelectedWorkPlan,
	updateSchedulePatternsTemplatesDetails,
	updateShiftTemplatesDetails,
	updateManageShiftLines,
	updateSnackbar,
	updateSelectedPaycode,
	updatePaycodeList,
	updateSidePanelData,
	updateEmployeeList,
	updateDataviewData,
	updateDataviewColumns,
	updateTotalsColumns,
	updateTableColumns,
	initWorkplanObjectsLists,
	updateSelectAllShiftLines,
	updateSelectAll,
	manageShiftLines,
	updateGetWorkplanDetails,
	updateSelectedPaycodeColumns,
	updateSelectedPaycodeColumnsSidePanelData,
	updateWorkplanWarnings,
	updateWorkplanAsyncTaskProgress,
	setWorkplanWarningsToLoading,
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('workplanManager')(withStyles(styles)(WorkPlanView)));
